// Reactivo, cuando cambia el state se notifica a todos lados donde esten escuchando los cambios del state
export default () => ({});
